type NavigatorOutcome = 'failed' | 'restored';

export const navigatorOutcome = (
  navigation: Promise<unknown>
): Promise<NavigatorOutcome> =>
  navigation.then(result => (result === null ? 'failed' : 'restored'));
